import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-1khyux0-0"
})(["display:flex;justify-content:space-between;padding:8px 12px 0;border-top:1px solid ", ";margin:0 -12px;> *{width:50%;max-width:240px;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 60px;\n    margin-bottom: 120px;\n  "]))));